import type { RouteType, RouteContext } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import type DashboardStore from "../shared/DashboardStore";

/**
 * Executive (CEO) dashboard. `enableAutoFind` is off because the data comes
 * from two custom find-only aggregates rather than an entity list — the store
 * fetches both in onEnter.
 */
const executiveRoute: RouteType = {
  name: "Executive Dashboard",
  title: "Executive Dashboard",
  path: "/dashboards/executive",
  layout: "/app",
  group: "Dashboards",
  requiresAuth: true,
  requiresPermission: false,
  enableAutoFind: false,
  viewportCard: {
    header: {
      title: "Executive Dashboard",
      enableRefreshButton: true,
      component: () => import("./Executive.Header"),
    },
    body: {
      component: () => import("./Executive.Body"),
      grayBackground: true,
    },
  },
  onEnter: async ({ rootStore }: RouteContext) => {
    const store = (rootStore as RootStore & { dashboardStore?: DashboardStore })
      .dashboardStore;
    if (store) await store.loadData();
  },
};

export default executiveRoute;
